import React from 'react';

import { Button } from '@infoods/lifebase-ui';

import classes from './SubmitButton.module.scss';
import { reloadPage } from '../../../../../shared/utils/windowUtils';

type SubmitButtonProps = {
  text?: string;
  formId?: string;
  disabled?: boolean;
  onSubmit?: () => void;
  hideBackToFirstPage?: boolean;
};

const SubmitButton = ({
  text = 'Next',
  formId,
  disabled,
  onSubmit,
  hideBackToFirstPage,
}: SubmitButtonProps) => {
  return (
    <div className={classes.buttonContainer}>
      {!hideBackToFirstPage && (
        <Button variant="outlined" size="large" onClick={reloadPage}>
          Back to the First Page
        </Button>
      )}
      <Button
        className={classes.submitButton}
        disabled={disabled}
        type="submit"
        variant="contained"
        size="large"
        onClick={onSubmit}
        form={formId}
      >
        {text}
      </Button>
    </div>
  );
};

export { SubmitButton };
